angular.module('mercury.modules.qa.wizbang', []);
